import { jsx } from 'react/jsx-runtime';
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import ValueStore from '@dtvgo/value-store';
import { PlayerActionsContext, PlayerMaxTimeShiftContext, PlayerDurationContext, AudioTracksContext, SubtitleTracksContext, PlayerViewModeContext, PlayerVolumeContext, PlayerSeekingContext, PlayerStateContext, PlayerBufferingContext, PlayerCurrentTimeContext, PlayerTimeContext } from './contexts.js';
import { PlayerState, PlayerViewMode } from './constants.js';
import { EMPTY_ARRAY, noop } from './utils.js';

function Provider({
  state = new ValueStore(PlayerState.UNKNOWN),
  buffering = new ValueStore(false),
  seeking = new ValueStore({ isSeeking: false, time: void 0 }),
  viewMode = new ValueStore(PlayerViewMode.INLINE),
  time = new ValueStore(0),
  currentTime = new ValueStore(0),
  duration = new ValueStore(0),
  maxTimeShift = new ValueStore(0),
  volume = new ValueStore(100),
  audioTracks = new ValueStore(EMPTY_ARRAY),
  subtitleTracks = new ValueStore(EMPTY_ARRAY),
  actions: {
    play = noop,
    pause = noop,
    togglePlayPause = noop,
    goToFullScreen = noop,
    exitFullScreen = noop,
    toggleFullScreen = noop,
    seek = noop,
    rewind = noop,
    goToLive = noop,
    setVolume = noop,
    toggleMute = noop,
    selectAudioTrack = noop,
    selectSubtitleTrack = noop,
    disableSubtitles = noop,
    getAvailableAudio = noop,
    getAvailableSubtitles = noop
  } = {},
  children = void 0
}) {
  const actions = useMemo(() => ({
    play,
    pause,
    togglePlayPause,
    goToFullScreen,
    exitFullScreen,
    toggleFullScreen,
    seek,
    rewind,
    goToLive,
    setVolume,
    toggleMute,
    selectAudioTrack,
    selectSubtitleTrack,
    disableSubtitles,
    getAvailableAudio,
    getAvailableSubtitles
  }), [
    play,
    pause,
    togglePlayPause,
    goToFullScreen,
    exitFullScreen,
    toggleFullScreen,
    seek,
    rewind,
    goToLive,
    setVolume,
    toggleMute,
    selectAudioTrack,
    selectSubtitleTrack,
    disableSubtitles,
    getAvailableAudio,
    getAvailableSubtitles
  ]);
  return /* @__PURE__ */ jsx(PlayerActionsContext.Provider, { value: actions, children: /* @__PURE__ */ jsx(PlayerMaxTimeShiftContext.Provider, { value: maxTimeShift, children: /* @__PURE__ */ jsx(PlayerDurationContext.Provider, { value: duration, children: /* @__PURE__ */ jsx(AudioTracksContext.Provider, { value: audioTracks, children: /* @__PURE__ */ jsx(SubtitleTracksContext.Provider, { value: subtitleTracks, children: /* @__PURE__ */ jsx(PlayerViewModeContext.Provider, { value: viewMode, children: /* @__PURE__ */ jsx(PlayerVolumeContext.Provider, { value: volume, children: /* @__PURE__ */ jsx(PlayerSeekingContext.Provider, { value: seeking, children: /* @__PURE__ */ jsx(PlayerStateContext.Provider, { value: state, children: /* @__PURE__ */ jsx(PlayerBufferingContext.Provider, { value: buffering, children: /* @__PURE__ */ jsx(PlayerCurrentTimeContext.Provider, { value: currentTime, children: /* @__PURE__ */ jsx(PlayerTimeContext.Provider, { value: time, children }) }) }) }) }) }) }) }) }) }) }) });
}
Provider.propTypes = {
  state: PropTypes.instanceOf(ValueStore),
  buffering: PropTypes.instanceOf(ValueStore),
  seeking: PropTypes.instanceOf(ValueStore),
  viewMode: PropTypes.instanceOf(ValueStore),
  time: PropTypes.instanceOf(ValueStore),
  currentTime: PropTypes.instanceOf(ValueStore),
  duration: PropTypes.instanceOf(ValueStore),
  maxTimeShift: PropTypes.instanceOf(ValueStore),
  volume: PropTypes.instanceOf(ValueStore),
  audioTracks: PropTypes.instanceOf(ValueStore),
  subtitleTracks: PropTypes.instanceOf(ValueStore),
  actions: PropTypes.shape({
    play: PropTypes.func,
    pause: PropTypes.func,
    togglePlayPause: PropTypes.func,
    goToFullScreen: PropTypes.func,
    exitFullScreen: PropTypes.func,
    toggleFullScreen: PropTypes.func,
    seek: PropTypes.func,
    rewind: PropTypes.func,
    goToLive: PropTypes.func,
    setVolume: PropTypes.func,
    toggleMute: PropTypes.func,
    selectAudioTrack: PropTypes.func,
    selectSubtitleTrack: PropTypes.func,
    disableSubtitles: PropTypes.func,
    getAvailableAudio: PropTypes.func,
    getAvailableSubtitles: PropTypes.func
  }),
  children: PropTypes.node
};
var Provider$1 = memo(Provider);

export { Provider$1 as default };
//# sourceMappingURL=Provider.js.map
